/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapporten_Config_Elements_HandoutInputs */

const nl_rapporten_config_elements_handout = /** @type {(inputs: Rapporten_Config_Elements_HandoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg informatieblad toe`)
};

/**

* @param {Rapporten_Config_Elements_HandoutInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const rapporten_config_elements_handout = /** @type {((inputs?: Rapporten_Config_Elements_HandoutInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapporten_Config_Elements_HandoutInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_rapporten_config_elements_handout(inputs)
});
export { rapporten_config_elements_handout as "rapporten.config.elements.handout" }